







// 引入所有的 svg
const importAll = (requireContext: __WebpackModuleApi.RequireContext) => requireContext.keys().forEach(requireContext);
try {importAll(require.context('../assets/icons/', true, /\.svg$/));} catch (error) {console.log(error);}

export default {
  props: ['name'],
  name: 'Icon'
};
